// `image.tweak`: an image from one or more reference images, as the prompt says (D3).
// Its first reference is the source; the rest are the references from the library
// (#233). On a delivered output it is live's Tweak (`image/tweak.ts`, #678): that one image,
// `edit: "tweak"`. Live's preview title for a tweak is "Image Details".
import { ImageTweakQuote, ImageTweakRequest } from "../../../api/generated/zod";
import { isTweak } from "../image/tweak";
import type { JobTypeModule } from "./contract";
import { commonFields, sourcesOf } from "./shared";

export const jobType: JobTypeModule<"image.tweak"> = {
  type: "image.tweak",
  label: "Tweak",
  detailTitle: "Image Details",
  source: "image",
  pair: "image.simple",
  fields: (draft) => {
    // The product whose photo the source is, for the Library's Product filter (spec
    // image-products); an earlier output's products the start copies itself.
    const products = draft.sourceProduct === null ? {} : { product_ids: [draft.sourceProduct] };
    return isTweak(draft)
      ? { ...commonFields(draft), references: sourcesOf(draft), edit: "tweak" as const, ...products }
      : { ...commonFields(draft), references: [...sourcesOf(draft), ...draft.references], ...products };
  },
  request: ImageTweakRequest,
  quote: ImageTweakQuote,
};
